var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkRegular = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45247 11.1365L8.67946 9.90018C7.87396 9.77843 7.30262 9.50681 6.89987 9.10405C5.67288 7.88644 5.67288 6.17239 6.88113 4.96414L9.32572 2.52891C10.534 1.31128 12.2387 1.31128 13.4563 2.52891C14.6833 3.76526 14.6739 5.46056 13.475 6.66881L12.3698 7.77403C12.6227 8.37347 12.707 9.09469 12.5852 9.70349L14.6083 7.68974C16.4535 5.85395 16.4535 3.25012 14.599 1.39558C12.7444 -0.468314 10.1406 -0.458953 8.29545 1.38622L5.7478 3.94321C3.90265 5.77902 3.90265 8.38285 5.75716 10.2467C6.14119 10.6308 6.67507 10.9399 7.45247 11.1365ZM8.54833 4.87048L7.32134 6.10683C8.11748 6.2286 8.6982 6.50022 9.10095 6.90297C10.3186 8.12059 10.3186 9.83462 9.11967 11.0429L6.67507 13.4781C5.46682 14.6957 3.76214 14.6864 2.54453 13.4688C1.31754 12.2418 1.31754 10.5371 2.52579 9.3382L3.63101 8.23298C3.36877 7.63354 3.29382 6.91234 3.41559 6.29416L1.39246 8.31729C-0.452694 10.1531 -0.452694 12.7569 1.40184 14.6114C3.25636 16.466 5.86019 16.4566 7.696 14.6208L10.253 12.0638C12.0888 10.2186 12.0982 7.61482 10.2436 5.76028C9.8596 5.37625 9.32572 5.06717 8.54833 4.87048Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkRegular);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LinkRegular.3f4e96a9905de044389aa40b4531ee5f.svg";